import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'seamless-immutable';
import { Segment, Dimmer, Loader, List, Image } from 'semantic-ui-react';
import { Empty } from '../views/Empty';
import { Error } from '../views/Error';
import { isArchived } from '../../helpers/project';
import { projectActions, uiActions } from '../../actions/index';
import Strings from '../../common/Strings';
import '../projects/ProjectsList.css';
import './TimerProjects.css';
import { store } from '../../helpers';
import Constant from '../../common/Constant';

class TimerProjects extends React.Component {
  fetchProjects = () => {
    const { dispatch } = this.props;
    dispatch(projectActions.fetchProjects());
  };

  addProjectClicked = () => {
    this.props.dispatch(uiActions.timerProjectClicked(undefined));
    this.props.dispatch(uiActions.addProjectClicked(true));
  };

  projectClicked = project => {
    if (store.getState().user.timer.status === Constant.TIMER_NOT_RUNNING) {
      this.props.dispatch(uiActions.addProjectClicked(false));
      this.props.dispatch(uiActions.timerProjectClicked(project.id));
    }
  };

  renderActiveProjects(activeProjects) {
    if (activeProjects.length === 0) {
      return (
        <Empty
          imageId="active-projects-empty-image"
          image="/emoji/bed.png"
          titleId="active-projects-empty-title"
          title={Strings.PROJECTS.activeProjectsEmptyTitle}
          bodyId="active-projects-empty-body"
          body={Strings.PROJECTS.activeProjectsEmptyBody}
        />
      );
    }

    const Children = activeProjects.map(project => {
      const companyName = project.companyName ? project.companyName : '';
      return (
        <List.Item
          className="project-list-item"
          style={{ backgroundColor: project.color }}
          key={project.id}
          onClick={() => this.projectClicked(project)}
        >
          <div style={{ display: 'flex', flexDirection: 'row', margin: 0 }}>
            <p className="project-list-item-text">{project.name}</p>
            {companyName && (
              <Image
                className="project-list-item-linked-image"
                src="/icon/linked-white.png"
              />
            )}
          </div>
        </List.Item>
      );
    });

    return <div>{Children}</div>;
  }

  renderContent() {
    if (this.props.failed) {
      return (
        <Error
          title={Strings.PROJECTS.failedTitle}
          body={Strings.PROJECTS.failedBody}
          buttonText={Strings.COMMON.tryAgain}
          buttonOnClick={this.fetchProjects}
        />
      );
    }

    const activeProjects = Immutable.flatMap(this.props.projects, project => {
      if (isArchived(project)) {
        return [];
      }
      return project;
    });

    let header;
    if (activeProjects.length > 0) {
      header = (
        <List.Item>
          <List.Content>
            <Image id="timer-clock-image" src="/emoji/clock.png" />
            <p id="timer-header-title">{Strings.TIMER.timerHeader}</p>
          </List.Content>
        </List.Item>
      );
    }

    return (
      <List className="projects-list">
        <List.Item>
          <List.Content>
            <div className="timer-title-container">
              <h1 id="timer-title-text" className="projects-list-title">
                {Strings.TIMER.timer}
              </h1>
              <button
                id="add-project-button"
                className="projects-list-add-project"
                onClick={this.addProjectClicked}
              >
                {Strings.PROJECTS.addProject}
              </button>
            </div>
            <div className="activity-today-divider" />
          </List.Content>
        </List.Item>
        {header}
        {this.renderActiveProjects(activeProjects)}
      </List>
    );
  }

  render() {
    return (
      <div className="projects-list-root">
        <Segment basic className="projects-list-container">
          <Dimmer active={this.props.loading} inverted>
            <Loader inverted />
          </Dimmer>
          {this.renderContent()}
        </Segment>
      </div>
    );
  }
}

TimerProjects.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  failed: PropTypes.bool,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      companyName: PropTypes.string,
    }),
  ),
};

TimerProjects.defaultProps = {
  loading: true,
  failed: false,
  projects: [],
};

const mapStateToProps = state => ({
  loading: state.uiState.isProjectsLoading,
  failed: state.uiState.isProjectsFailed,
  projects: state.projects,
});

export default connect(mapStateToProps)(TimerProjects);



// WEBPACK FOOTER //
// ./src/components/timer/TimerProjects.js